import { useFetch } from "@/hooks/useFetch";
import { api } from "@/lib/config";
import { useProject } from "@/modules/work/projects/context";

const useRevenue = () => {
    const {id} = useProject();
    const {data,isLoading,error} = useFetch({
        queryFn:async () => {
            const response = await api.get(`project-revenue-distribution?projectId=${id}`);
            return response.data;
        },
        queryKey: ["project-revenue-distribution", id],
    })
    return {data,isLoading,error}
}

export default useRevenue